import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 
import Box from '@mui/material/Box';
import Button from '../../../general/inputs/Button';
import InfoRow from '../../../general/inputs/InfoRow';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

interface Props { 
    handler: any; 
}; 

const Plan: React.FC<Props> = ({ handler }) => {
    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 
    const subscription = useAppSelector(state => state.billing.subscription); 

    return (
        <Box
            sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                // --- RESPONSIVE WIDTH ---
                width: '100%', 
                maxWidth: '400px', // Max width on desktop
                // --- REMOVED FIXED HEIGHT AND POSITION ---
                position: 'relative', // Relative for the background image
                borderRadius: 4, 
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)',
                backgroundColor: colors?.container,
                overflow: 'hidden', // Keep background image contained
                padding: 3, // Internal spacing
            }}
        >
            {/* Background Image */}
            <Box
                component="img"
                sx={{
                    width: '100%', 
                    height: '100%',
                    top: 0, 
                    left: 0, 
                    position: 'absolute',
                    opacity: 0.3,
                    objectFit: 'cover', // Ensure image covers the area
                }}
                alt="Plan Background"
                src={require('../../../../assets/icons/login/juyt_6.jpg')}
            />

            {/* Content Wrapper - zIndex ensures it's on top of the background */}
            <Box
                sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%', 
                    zIndex: 1,
                }}
            >
                <Box
                    sx={{ 
                        width: '100%', 
                        fontSize: 14, 
                        color: colors?.main,
                        textAlign: 'left',
                        mb: 1,
                    }}
                >{t('pro')} 
                </Box>

                <Box
                    sx={{ 
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between', 
                        width: '100%', 
                        mb: 3, 
                    }}
                >
                    <Box sx={{ fontSize: 25, fontWeight: 'bold', color: colors?.main }}>
                        {t('clinic')}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'flex-end', color: colors?.text, fontSize: 22 }}>
                        $95/
                        <Box sx={{ fontSize: 15, ml: 0.5, mb: 0.5 }}>{t('month')}</Box>
                    </Box>
                </Box>

                <Button 
                    title={((subscription?.status === 'trialing') || (subscription?.status === 'active')) ? 'addSeats' : 'subscribe'}
                    triggerFunction={handler}
                    extraStyle={{ 
                        width: '80%', 
                        mb: 3, 
                        py: 1.5,
                    }}
                />

                <Box
                    sx={{ 
                        textAlign: 'center', 
                        width: '80%', 
                        mb: 3, 
                        fontSize: 12, 
                        color: 'rgb(160, 160, 160)'
                    }}
                >{t('paywallBoxDescription')}
                </Box>

                <Box
                    sx={{ 
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%', 
                        gap: 1,
                    }}
                >
                    <InfoRow 
                        title={t('paywallProPoint1')}
                        description={<CheckCircleOutlineIcon sx={{ color: 'rgb(16, 16, 150)' }} />}
                        isDisabled
                    />
                    <InfoRow 
                        title={t('paywallProPoint2')}
                        description={<CheckCircleOutlineIcon sx={{ color: 'rgb(16, 16, 150)' }} />}
                        isDisabled
                    />
                    <InfoRow 
                        title={t('paywallProPoint3')}
                        description={<CheckCircleOutlineIcon sx={{ color: 'rgb(16, 16, 150)' }} />}
                        isDisabled
                    />
                    <InfoRow 
                        title={t('paywallProPoint4')}
                        description={<CheckCircleOutlineIcon sx={{ color: 'rgb(16, 16, 150)' }} />}
                        isDisabled
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default Plan;